import React from 'react';
import { ApolloClient, ApolloProvider, HttpLink, ApolloLink, InMemoryCache } from '@apollo/client';
import Session, { ACCESS_TOKEN, SESSION_STATE } from '../Session';
import branding from '@config/branding';
const httpLink = new HttpLink({
  uri: branding.services.gql
});
const middlewareAuthLink = new ApolloLink((operation, forward) => {
  const authorization = ACCESS_TOKEN ? `Bearer ${ACCESS_TOKEN}` : null;
  operation.setContext({
    headers: {
      authorization
    }
  });
  return forward(operation);
});
const client = new ApolloClient({
  link: middlewareAuthLink.concat(httpLink),
  cache: new InMemoryCache()
});

const ServicesConfig = ({
  defaultSession,
  children
}) => {
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, /*#__PURE__*/React.createElement(Session, {
    defaults: SESSION_STATE || defaultSession
  }, children));
};

ServicesConfig.defaultProps = {
  defaultSession: {
    received_once: false,
    initial: true,
    loading: true,
    token: null,
    user: null,
    redirect: null,
    others: {}
  }
};
export default ServicesConfig;